import axios from 'axios';
import { constants, sendAjaxBatchCall } from '@skunexus/utils';

const {
    CONFIG: { API_PATH },
} = constants;

export function changeStatus({ userId, data }) {
    return axios.patch(`${API_PATH}/users/${userId}/custom-values`, data);
}

export function bulkChangeStatus({ data = [] }) {
    const requests = data.map(({ userId, data }) => ({
        method: 'patch',
        url: `${API_PATH}/users/${userId}/custom-values`,
        content: data,
    }));

    return sendAjaxBatchCall({
        requests: [...requests],
    });
}
